import { useAtomValue } from 'jotai';
import React from 'react';

import { ReceptionDrawerFileArea } from '~/components/layouts/ReceptionDrawer/FileArea';
import { ReceptionFileType } from '~/constants/reception_file_type';
import { appointmentPatientFileAreaState } from '~/state/reception_drawer/atoms';

import { InsuranceCard } from './InsuranceCard';
import { Prescription } from './Prescription';
import { Questionnaire } from './Questionnaire';

type Props = {
  onClose: () => void;
};

export const FileArea = (props: Props) => {
  const { type } = useAtomValue(appointmentPatientFileAreaState);

  return (
    <ReceptionDrawerFileArea onClose={props.onClose}>
      {type === ReceptionFileType.prescription && <Prescription />}
      {type === ReceptionFileType.insuranceCard && <InsuranceCard />}
      {type === ReceptionFileType.questionnaire && <Questionnaire />}
    </ReceptionDrawerFileArea>
  );
};
